import { access } from '@driftt/traffic-control'

import { OPERATORS } from './Operators'

const {
  IS,
  IS_NOT,
  IS_ANY,
  IS_NOT_ANY,
  CONTAINS_EXACT,
  DOES_NOT_CONTAIN_EXACT,
  IS_PRESENT,
  IS_NOT_PRESENT,
  GT,
  LT,
  IS_BEFORE,
  IS_AFTER,
  IS_BEFORE_RELATIVE,
  IS_AFTER_RELATIVE,
  HAS_OCCURRED_EXACTLY
} = OPERATORS

export const PROPERTY_TYPES = {
  BOOLEAN: { operators: [IS, IS_PRESENT, IS_NOT_PRESENT] },
  DATE: { operators: [IS, IS_NOT, IS_PRESENT, IS_NOT_PRESENT, IS_BEFORE, IS_AFTER, IS_BEFORE_RELATIVE, IS_AFTER_RELATIVE] },
  DATETIME: { operators: [IS_PRESENT, IS_NOT_PRESENT, IS_BEFORE, IS_AFTER, IS_BEFORE_RELATIVE, IS_AFTER_RELATIVE] },
  STRING: {
    // Gated due to performance concerns.
    operators:[IS, IS_NOT, ...[].concat(access.hasGates('has_is_any_operator') ? [IS_ANY, IS_NOT_ANY] : []), CONTAINS_EXACT, DOES_NOT_CONTAIN_EXACT, IS_PRESENT, IS_NOT_PRESENT]
  },
  NUMERIC: { operators:[IS, IS_NOT, ...[].concat(access.hasGates('has_is_any_operator') ? [IS_ANY, IS_NOT_ANY] : []), IS_PRESENT, IS_NOT_PRESENT, GT, LT] },
  CONTACT_TAG: { operators: [IS_PRESENT, IS_NOT_PRESENT] },
  EVENT: { operators: [IS_PRESENT, IS_NOT_PRESENT, HAS_OCCURRED_EXACTLY, IS_BEFORE, IS_AFTER, IS_BEFORE_RELATIVE, IS_AFTER_RELATIVE] },
  PLAYBOOK: { operators: [IS_PRESENT, IS_NOT_PRESENT, IS_BEFORE, IS_AFTER, IS_BEFORE_RELATIVE, IS_AFTER_RELATIVE] }
}
